import { hasPrivilege, ObjectPrivilege } from 'cadenza/access-management/object-privilege';
import { LayerProperty } from 'cadenza/map/layer-property';
import { MapProperty } from 'cadenza/map/map-property';
import { ClassicSketchLayer } from 'cadenza/map/classic-sketch-layer/classic-sketch-layer';
import { SketchLayerProperty } from 'cadenza/map/classic-sketch-layer/sketch-layer-property';

export function getSketchState (map, layer) {
  const isSketchLayer = layer instanceof ClassicSketchLayer;
  const currentSketchLayer = map.get(MapProperty.SKETCH_LAYER);
  const isEditing = layer === currentSketchLayer;
  const isSaving = layer.get(SketchLayerProperty.IS_SAVING);
  const isSaved = layer.get(SketchLayerProperty.IS_REPOSITORY_ITEM_THEME);
  const isSavedInDb = isSaved && layer.get(SketchLayerProperty.IS_VERSION_THEME);
  const canWriteInDBRepo = window.Disy.isWritableDatabaseRepositoryAvailable;
  const privileges = layer.get(LayerProperty.PRIVILEGES);
  const hasWritePrivilegeOnLayer = hasPrivilege(privileges, ObjectPrivilege.write);
  const isOwnerOfLayer = hasPrivilege(privileges, ObjectPrivilege.share);
  const canSaveAsNewItemToDb = canWriteInDBRepo && (!isSavedInDb || isOwnerOfLayer); // Share currently implies beeing owner
  const lastSavedDate = layer.get(SketchLayerProperty.LAST_SAVED_DATE);
  const canEditLayer = isSketchLayer && (isSavedInDb ? hasWritePrivilegeOnLayer : (!canWriteInDBRepo || canSaveAsNewItemToDb));
  const sharedWithEditPrivilegeButNotAllowedToEditInDBRepo = isSaved && hasWritePrivilegeOnLayer && !canWriteInDBRepo;
  return {
    isSketchLayer,
    currentSketchLayer,
    canEditLayer,
    isEditing,
    isSaving,
    isSaved,
    isSavedInDb, // DB repo items have a version.
    canSaveAsNewItemToDb,
    sharedWithEditPrivilegeButNotAllowedToEditInDBRepo,
    lastSavedDate
  };
}

export function updateLastSaveDate (layer) {
  layer.set(SketchLayerProperty.LAST_SAVED_DATE, new Date());
}
